import { useUserListsManager } from "@hooks/use-userlists";
import UserListHorizontalCard from "./UserListHorizontalCard";

function UserLists({ onUserListClick }) {
  const { userLists } = useUserListsManager();

  if (userLists.length === 0) return null;

  return (
    <div className="d-flex flex-column gap-2 w-100">
      {userLists.map((userList, index) => (
        <UserListHorizontalCard
          key={`${userList.id}-${index}`}
          userList={userList}
          onClick={() => onUserListClick(userList)}
          trackingName="ChooseUserlistFromOffcanvas"
        />
      ))}
    </div>
  );
}

export default UserLists;
